import {Injectable, Injector} from '@angular/core';
import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, filter, finalize, switchMap, take} from 'rxjs/operators';
import {AuthService} from '@services/auth.service';
import {User} from '@app/modules/operations-api/models';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  user: User;
  authService = this.injector.get(AuthService);
  routes = [
    '/account/login'
  ];

  constructor(
    private injector: Injector
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse |
    HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
    let skip = false;
    this.routes.forEach((i) => {
      if (request.url.includes(i)) {
        skip = true;
      }
    });
    if (skip) {
      return next.handle(request);
    } else {
      return next.handle(this.addTokenToRequest(request, this.authService.getAuthToken()))
        .pipe(
          catchError(err => {
            if (err instanceof HttpErrorResponse) {
              switch ((<HttpErrorResponse>err).status) {
                case 401: {
                  // if unauthorised via a refreshToken call fail then logout
                  if (this.isRefreshingToken) {
                    this.authService.logout();
                    return throwError(err);
                  } else {
                    return this.handle401Error(request, next);
                  }
                }
                // case 400:
                //   return <any>this.authService.logout();
                // default: {
                //   return throwError(err);
                // }
                default:
                  return throwError(err);
              }
            } else {
              return throwError(err);
            }
          })
        );
    }
  }

  private addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    if (token) {
      return request.clone({setHeaders: {Authorization: `Bearer ${token}`}});
    } else {
      return request;
    }
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next(null);

      return this.authService.refreshToken()
        .pipe(
          switchMap((user: User) => {
            if (user) {
              this.tokenSubject.next(user.accessToken);
              return next.handle(this.addTokenToRequest(request, user.accessToken));
            }
            return <any>this.authService.logout();
          }),
          catchError(err => {
            return <any>this.authService.logout();
          }),
          finalize(() => {
            this.isRefreshingToken = false;
          })
        );
    } else {
      this.isRefreshingToken = false;
      return this.tokenSubject
        .pipe(filter(token => token != null),
          take(1),
          switchMap(token => {
            return next.handle(this.addTokenToRequest(request, token));
          }));
    }
  }
}
